import * as React from "react";
const Visage2 = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 408 1220" {...props}>
		<defs>
			<style>
				{".cls-1{fill:none;}.cls-2{stroke:#000;stroke-miterlimit:10;}"}
			</style>
		</defs>
		<title>{"visage 2"}</title>
		<g id="cadre">
			<rect className="cls-1" width={408} height={1220} />
		</g>
		<g id="Calque_7" data-name="Calque 7">
			<g id="frames_1" data-name="frames 1">
				<ellipse className="cls-2" cx={226.5} cy={140} rx={5.5} ry={10} />
				<ellipse className="cls-2" cx={265.5} cy={140} rx={5.5} ry={10} />
				<path
					className="cls-2"
					d="M1122.55,606.33s12.28.8,14.33-7.27c1-1.61,5.12-1.61,5.12,1.62s-7.17,10.49-16.38,8.88S1122.55,606.33,1122.55,606.33Z"
					transform="translate(-878.5 -427.5)"
				/>
				<path
					className="cls-2"
					d="M1102.5,626.5s23,4,31-3c5-2,4,3,3,4s-11,12-34,5C1095.5,627.5,1102.5,626.5,1102.5,626.5Z"
					transform="translate(-878.5 -427.5)"
				/>
			</g>
		</g>
	</svg>
);
export default Visage2;
